import { render } from "./holdTelefonico.vue?vue&type=template&id=63b6fb00&ts=true"
import script from "./holdTelefonico.vue?vue&type=script&lang=ts"
export * from "./holdTelefonico.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__